import React from 'react'
import '../styles/RealEstate.styles.css'
import sala from '../assets/inmb1.jpg'
import rec from '../assets/inmb2.jpg'
import entrada from '../assets/entradaP.jpg'
import logoPerla from '../assets/laPerla.png'
import { useOnScreen } from "../hooks/useOnScreen";

export default function RealEstate() {
  const [ref, isVisible] = useOnScreen({ threshold: 0.3 });
  return (
    <section className='realEstate' id='inmobiliaria'>
      <div className='re-container'>
        <div className='re-imageContainer1'>
          <div className='inmImg'>
            <div className='upImg1'>
              <div className='contDivBlue'>
                <div ref={ref} className={`divBlueInmb ${isVisible?"is-visible":""}`}>
                  <div className='divTxtInmb'>
                    <p>
                      2 Recámaras <br/>
                      Sala/Comedor<br/>
                      Cocina <br/>
                      Patio de servicio <br/>
                    </p>
                  </div>
                  <div className='divTxtInmb'>
                    <p>
                      1 baño y medio <br/>
                      Garage para un auto <br/>
                      Cisterna de 11,000 lts
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='re-imageContainer2'>
          <div className='divImgInmb1'>
            <div ref={ref} className={`inmSala ${isVisible?"is-visible":""}`}>
              <img src={sala} alt='rosmo'/>
            </div>
            <div ref={ref} className={`inmRec ${isVisible?"is-visible":""}`}>
              <img src={rec} alt='rosmo'/>
            </div>
          </div>
          <div className='divImgInmb2'>
            <div ref={ref} className={`logoPerla ${isVisible?"is-visible":""}`}>
              <img src={logoPerla} alt='rosmo'/>
            </div>
            <div ref={ref} className={`entradaFrac ${isVisible?"is-visible":""}`}>
              <img src={entrada} alt='rosmo'/>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
